import { useContext } from "react";
import { I18nContext } from "../../i18n/useI18n";
import PrincipalBanner from "../../contents/PrincipalBanner";
import { twMerge } from "tailwind-merge";
import clsx from "clsx";

const modelingContent = "pages.project.modeling";

const ModelingPage = () => {
  const { t } = useContext(I18nContext);

  return (
    <main className="mx-auto my-0 max-w-7xl">
      <PrincipalBanner
       
        classNames={twMerge(clsx("min-h-[200px] md:min-h-[400px]"))}
      >
        <img
          className="absolute w-full min-h-full object-cover"
          src=" https://static.igem.wiki/teams/5058/novas-imagens/banner-novo-modeling.webp "
          alt="banner education"
        />
        <h1 className="invisible">{t(`${modelingContent}.title`)}</h1>
      </PrincipalBanner>
      <section className="px-6 py-8">
        <h2>{t(`${modelingContent}.introduction.title`)}</h2>
        <p>{t(`${modelingContent}.introduction.text`)}</p>
        <p>{t(`${modelingContent}.introduction.text2`)}</p>
        <p>{t(`${modelingContent}.introduction.text3`)}</p>
      </section>
      <section className="px-6 py-8">
        <h2>{t(`${modelingContent}.figure1.title`)}</h2>
        <p className="text-center">
          <img
            className="inline-block w-30 min-h-full object-cover"
            src="https://static.igem.wiki/teams/5058/modeling.svg"
            alt="bannner engineering"
          />
        </p>
        <p>{t(`${modelingContent}.figure1.text`)}</p>
      </section>
      <section className="px-6 py-8">
        <h2>{t(`${modelingContent}.fba.title`)}</h2>
        <p>{t(`${modelingContent}.fba.text`)}</p>
        <p>{t(`${modelingContent}.fba.text2`)}</p>
      </section>
      <section className="px-6 py-8">
        <h2>{t(`${modelingContent}.figure2.title`)}</h2>
        <p className="text-center">
          <img
            className="inline-block w-30 min-h-full object-cover"
            src="https://static.igem.wiki/teams/5058/saved-map-2.svg"
            alt="bannner engineering"
          />
        </p>
        <p>{t(`${modelingContent}.figure2.text`)}</p>
      </section>
      <section className="px-6 py-8">
        <h2>{t(`${modelingContent}.fba2.title`)}</h2>
        <p>{t(`${modelingContent}.fba2.text`)}</p>
      </section>
      <section className="px-6 py-8">
        <h2>{t(`${modelingContent}.figure3.title`)}</h2>
        <p className="text-center">
          <img
            className="inline-block w-30 min-h-full object-cover"
            src="https://static.igem.wiki/teams/5058/saved-map-1.svg"
            alt="bannner engineering"
          />
        </p>
        <p>{t(`${modelingContent}.figure3.text`)}</p>
      </section>
      <section className="px-6 py-8">
        <h2>{t(`${modelingContent}.degron.title`)}</h2>
        <p>{t(`${modelingContent}.degron.text`)}</p>
        <p>{t(`${modelingContent}.degron.text2`)}</p>
        <p>{t(`${modelingContent}.degron.text3`)}</p>
      </section>
      <section className="px-6 py-8">
        <h2>{t(`${modelingContent}.pho85.title`)}</h2>
        <p>{t(`${modelingContent}.pho85.text`)}</p>
        <p>{t(`${modelingContent}.pho85.text2`)}</p>
        <p>{t(`${modelingContent}.pho85.text3`)}</p>
      </section>
      <section className="px-6 py-8">
        <h2>{t(`${modelingContent}.figure4.title`)}</h2>
        <p className="text-center">
          <img
            className="inline-block w-30 min-h-full object-cover"
            src="https://static.igem.wiki/teams/5058/ptn1modeling.svg"
            alt="bannner engineering"
          />
        </p>
        <p>{t(`${modelingContent}.figure4.text`)}</p>
      </section>

      <section className="px-6 py-8">
        <p>
          In the Pho85-AID6HA model (Figure 3), the mAID6HA tag was also
          significantly exposed, increasing the likelihood of interaction with
          TIR1 and, consequently, the activation of the DEGRON system. The
          structural alignment with Pho85 revealed a subtle RMSD value variation
          of 0.439, which is a promising indication that the activity of the
          Pho85 protein will likely remain uncompromised. Considering this, we
          designed a biological circuit that may integrate the DEGRON system in
          our engineered yeast.
        </p>
        <p>
          <img
            src="https://static.igem.wiki/teams/5058/ptn2modeling.svg"
            alt=""
          />
        </p>
        <p>
          Figure3 - Structural Prediction Analysis of the Pho85 Protein
          Associated with the AID Tag and 6HA Marker. The native Pho85 model is
          shown in yellow, while the Pho85 model with the AID6HA tag is depicted
          in magenta, with the mAID site highlighted in cyan. The structural
          alignment between the two models indicates an RMSD of 0.439.
        </p>
      </section>
    </main>
  );
};

export default ModelingPage;
